/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DisableEnableChargingTask
 */
export interface DisableEnableChargingTask {
    /**
     *
     * @type {number}
     * @memberof DisableEnableChargingTask
     */
    connectorIndex?: number;
    /**
     *
     * @type {boolean}
     * @memberof DisableEnableChargingTask
     */
    enable?: boolean;
}

/**
 * Check if a given object implements the DisableEnableChargingTask interface.
 */
export function instanceOfDisableEnableChargingTask(
    value: object,
): value is DisableEnableChargingTask {
    return true;
}

export function DisableEnableChargingTaskFromJSON(
    json: any,
): DisableEnableChargingTask {
    return DisableEnableChargingTaskFromJSONTyped(json, false);
}

export function DisableEnableChargingTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DisableEnableChargingTask {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        enable: json["enable"] == null ? undefined : json["enable"],
    };
}

export function DisableEnableChargingTaskToJSON(
    value?: DisableEnableChargingTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        enable: value["enable"],
    };
}
